import React from 'react';

import TextStyleIcon from '@atlaskit/icon/core/text-style';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const barStyles = xcss({
	position: 'absolute',
	left: 'space.0',
	right: 'space.0',
	top: '18px',
	margin: 'auto',
	width: token('space.200'),
	height: '3px',
});

const textColorIconWrapper = xcss({
	position: 'relative',
});

type TextColorIconProps = {
	isDisabled?: boolean;
	isSelected?: boolean;
	selectedColor: string;
	testId: string;
};

export const TextColorIcon = ({
	selectedColor,
	isSelected = false,
	testId,
	isDisabled,
}: TextColorIconProps) => {
	let textColor: ReturnType<typeof token> = isSelected
		? token('color.text.selected')
		: token('color.text.subtle');
	if (isDisabled) {
		textColor = token('color.text.disabled');
	}
	return (
		<Box testId={testId} xcss={textColorIconWrapper}>
			<TextStyleIcon label="" spacing="spacious" color={textColor} />
			<Box
				style={{ background: isDisabled ? token('color.background.disabled') : selectedColor }}
				xcss={barStyles}
			/>
		</Box>
	);
};
